import camelcaseKeys from 'camelcase-keys';
import { z } from 'zod';

const mapFieldToCamelCase = (field: string) =>
  field.replace(/_([a-z0-9])/g, (_match, letter: string) => letter.toUpperCase());

// One issue of a validation error; `field` is absent when the issue is not about a single field.
// The API names the field in snake_case; it comes out camelCased, like every other key the client returns.
const ErrorEnvelopeDetailSchema = z
  .object({ field: z.string().optional(), code: z.string(), message: z.string() })
  .transform(({ field, ...detail }) => ({ ...detail, field: field && mapFieldToCamelCase(field) }));

/**
 * Manage API error envelope (Tools ADR-0020, not this repo's ADR-020), sent on every status, e.g.
 * `{ error: { code: 'REPORT_RUN_QUOTA_EXCEEDED', message, request_id } }`. `details` comes with
 * validation errors and `retry_after` (seconds) with rate limits. Unwraps to the camelCased `error` object.
 */
export const ErrorEnvelopeSchema = z
  .object({
    error: z.object({
      code: z.string(),
      message: z.string(),
      details: z.array(ErrorEnvelopeDetailSchema).optional(),
      retry_after: z.number().optional(),
      request_id: z.string().optional()
    })
  })
  .transform(({ error }) => camelcaseKeys(error));

/** Machine `code`, message and optional details, retry delay and request id of a Manage API error. */
export type ErrorEnvelopeBody = z.output<typeof ErrorEnvelopeSchema>;
